import {Theme, createStyles, lighten} from '@material-ui/core';

export const performanceBlockStyles = (theme: Theme) =>
	createStyles({
		root: {
			position: 'relative',
			marginTop: theme.spacing(10),
			marginBottom: theme.spacing(10),
			overflow: 'hidden',

			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				marginBottom: 0,
			},
		},
		imageWrapper: {
			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				justifyContent: 'center',
				display: 'flex',
				marginBottom: theme.spacing(-5),
			},
		},
		auditImage: {
			position: 'absolute',
			zIndex: 3,
			bottom: theme.spacing(4),
			[theme.breakpoints.down(theme.breakpoints.values.md)]: {
				position: 'static',
				bottom: 'unset',
			},
			[theme.breakpoints.between(theme.breakpoints.values.md, theme.breakpoints.values.lg)]: {
				maxWidth: '50%',
			},
		},
		topBalloon: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.common.white,
			borderRadius: theme.spacing(5),
			padding: theme.spacing(13, 8, 13, 20),
			zIndex: 2,
			maxWidth: '100%',
			'& .MuiTypography-h4': {
				letterSpacing: '0.08em',
				fontSize: theme.typography.pxToRem(26),
				lineHeight: theme.typography.pxToRem(36),

				[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
					fontSize: theme.typography.pxToRem(15),
					lineHeight: theme.typography.pxToRem(26),
				},
			},
			'& .MuiTypography-body2': {
				paddingTop: theme.spacing(1),
				fontSize: theme.typography.pxToRem(16),
				lineHeight: theme.typography.pxToRem(22),

				[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
					fontSize: theme.typography.pxToRem(14),
					lineHeight: theme.typography.pxToRem(20),
				},
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				marginRight: theme.spacing(5),
				padding: theme.spacing(10, 6, 7.5, 6),
			},
		},
		bottomBalloon: {
			maxWidth: '100%',
			marginTop: theme.spacing(-8),
			backgroundColor: lighten(theme.palette.primary.light, 0.8),
			color: theme.palette.primary.main,
			borderRadius: theme.spacing(5),
			padding: theme.spacing(16, 3, 10, 26),
			marginRight: theme.spacing(8),
			marginLeft: theme.spacing(6),
			zIndex: 1,
			'& .MuiTypography-body1': {
				fontSize: theme.typography.pxToRem(20),
				lineHeight: theme.typography.pxToRem(32),
			},
			[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
				marginRight: 0,
				borderBottomRightRadius: 0,
				borderTopRightRadius: 0,
				marginTop: theme.spacing(-12),
				padding: theme.spacing(16, 3, 5, 8),

				'& .MuiTypography-body1': {
					fontSize: theme.typography.pxToRem(16),
					lineHeight: theme.typography.pxToRem(22),
				},
			},
		},
	});
